import { render, staticRenderFns } from "./StudentNote.vue?vue&type=template&id=53fb8b74&scoped=true"
import script from "./StudentNote.vue?vue&type=script&lang=js"
export * from "./StudentNote.vue?vue&type=script&lang=js"
import style0 from "./StudentNote.vue?vue&type=style&index=0&id=53fb8b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb8b74",
  null
  
)

export default component.exports